"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScript;

var _tslib = require("tslib");

var _react = require("react");

// This is from https://github.com/hupe1980/react-script-hook
function useIsMounted() {
  // set initial value
  var isMounted = (0, _react.useRef)(false);

  var callback = function callback() {
    // set that this is mounted
    isMounted.current = true; // teardown

    return function () {
      isMounted.current = false;
    };
  };

  (0, _react.useEffect)(callback, []);
  return isMounted;
} // tslint:disable


var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined"; // tslint:enable
//tslint:disable

function useScript(_a) {
  var src = _a.src,
      loadCondition = _a.loadCondition,
      attributes = (0, _tslib.__rest)(_a, ["src", "loadCondition"]);
  var isMounted = useIsMounted();

  var _b = (0, _react.useState)(true),
      loading = _b[0],
      setLoading = _b[1];

  var _c = (0, _react.useState)(null),
      error = _c[0],
      setError = _c[1];

  (0, _react.useEffect)(function () {
    if (loadCondition && loadCondition() === false) {
      return attributes.onload && attributes.onload();
    }

    if (!isBrowser) {
      return;
    }

    if (document.querySelector("script[src=\"" + src + "\"]")) {
      if (isMounted) {
        setLoading(false);
      }

      return;
    }

    var scriptEl = document.createElement("script");
    scriptEl.src = src;
    Object.keys(attributes).forEach(function (key) {
      return scriptEl[key] = attributes[key];
    });

    var handleLoad = function handleLoad() {
      if (isMounted) {
        setLoading(false);
      }
    };

    var handleError = function handleError(error) {
      if (isMounted) {
        setError(error);
      }
    };

    scriptEl.addEventListener("load", handleLoad);
    scriptEl.addEventListener("error", handleError);
    document.body.appendChild(scriptEl);
    return function () {
      scriptEl.removeEventListener("load", handleLoad);
      scriptEl.removeEventListener("error", handleError);
    };
  }, [src, attributes, isMounted]);
  return [loading, error];
}